import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { deleteApp, initializeApp } from "firebase/app";
import { Camera, Eye, EyeOff, Trash2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { doc, setDoc } from "firebase/firestore";
import { firestored, firebaseConfig } from "../../firebase/firebaseConfig"; // firebase setup
import { useStateValue } from "../../context/StateProvider";
import { isSuperAdminOwner } from "../../utils/brokerageSettings";
import { getAllusers, uploadImageToUser } from "../../utils/firebasefunctions";
import { Plus } from "lucide-react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { actionType } from "../../context/reducer";
import { formatNumber, removeCommas } from "../../utils/helper";
import BreadCrumbs from "../reuseable/breadcrumbs";
import PageHeader from "../PageHeader";

const ACCESS_LIST = [
  { key: "approveDeal", label: "Approve Deal" },
  { key: "deleteDeal", label: "Delete Deal" },
  { key: "underContract", label: "Under Contract" },
  { key: "pending", label: "Pending" },
  { key: "closed", label: "Closed" },
  { key: "closedVolume", label: "Closed Volume" },
  { key: "pendingVolume", label: "Pending Volume" },
  { key: "netVolume", label: "Net Volume" },
  { key: "commissionVolume", label: "Commission Volume" },
  { key: "pendingCommission", label: "Pending Commission" },
];

export default function MainUser() {
  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const page = searchParams.get("page");
  const [firstName, setFirstName] = useState("");
  const [isCheckFirstName, setIsCheckFirstName] = useState(false);
  const [lastName, setLastName] = useState("");
  const [isCheckLastName, setIsCheckLastName] = useState(false);
  const [email, setEmail] = useState("");
  const [rankingaccess, setrankingaccess] = useState(true);

  const [isCheckEmail, setIsCheckEmail] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCheckPhone, setIsCheckPhone] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [laoding, setlaoding] = useState(false);
  const [role, setRole] = useState("");
  const [isDemo, setIsDemo] = useState(false);
  const [isCheckrole, setIsCheckRole] = useState("");
  const [isCheckMatch, setIsCheckMatch] = useState(false);
  const [isCheckPassword, setIsCheckPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [isCheckConfirmPassword, setIsCheckConfirmPassword] = useState(false);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const CURRENT_YEAR = new Date().getFullYear();

  const [agentGoals, setAgentGoals] = useState([
    { year: CURRENT_YEAR, amount: "" },
  ]);
  const [agentunitsclosedgoal, setagentunitsclosedgoal] = useState([
    { year: CURRENT_YEAR, count: "" },
  ]);
  const [agentvolumesoledgoal, setagentvolumesoledgoal] = useState([
    { year: CURRENT_YEAR, amount: "" },
  ]);

  const [{ user, users }, dispatch] = useStateValue();

  const fileInputRef = useRef(null);

  const addGoalYear = () => {
    setAgentGoals((prev) => {
      const years = prev.map((item) => item.year);
      let newYear = CURRENT_YEAR;

      // find first missing year
      while (years.includes(newYear)) {
        newYear++;
      }

      return [
        ...prev,
        { id: Date.now() + Math.random(), year: newYear, amount: "" },
      ];
    });
  };

  const addClosedDealGoalYear = () => {
    setagentunitsclosedgoal((prev) => {
      const years = prev.map((item) => item.year);
      let newYear = CURRENT_YEAR;

      // find first missing year
      while (years.includes(newYear)) {
        newYear++;
      }

      return [
        ...prev,
        { id: Date.now() + Math.random(), year: newYear, count: "" },
      ];
    });
  };

  const addVolumeGoalYear = () => {
    setagentvolumesoledgoal((prev) => {
      const years = prev.map((item) => item.year);
      let newYear = CURRENT_YEAR;

      // find first missing year
      while (years.includes(newYear)) {
        newYear++;
      }

      return [
        ...prev,
        { id: Date.now() + Math.random(), year: newYear, amount: "" },
      ];
    });
  };

  const removeGoalYear = (index) => {
    setAgentGoals((prev) => prev.filter((_, i) => i !== index));
  };

  const removeclosedGoalYear = (index) => {
    setagentunitsclosedgoal((prev) => prev.filter((_, i) => i !== index));
  };

  const removedvolumegoalyear = (index) => {
    setagentvolumesoledgoal((prev) => prev.filter((_, i) => i !== index));
  };

  const updateGoalAmount = (index, value) => {
    setAgentGoals((prev) =>
      prev.map((item, i) => (i === index ? { ...item, amount: value } : item)),
    );
  };
  const updateclosedGoalAmount = (index, value) => {
    setagentunitsclosedgoal((prev) =>
      prev.map((item, i) => (i === index ? { ...item, count: value } : item)),
    );
  };

  const updateclosedvolumeAmount = (index, value) => {
    setagentvolumesoledgoal((prev) =>
      prev.map((item, i) => (i === index ? { ...item, amount: value } : item)),
    );
  };

  const [access, setAccess] = useState(() =>
    ACCESS_LIST.reduce((acc, item) => {
      acc[item.key] = true;
      return acc;
    }, {}),
  );

  const toggleAccess = (key) => {
    setAccess((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleRankingAccess = (key) => {
    setrankingaccess(!rankingaccess);
  };

  // Handle file selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImageFile(file); // actual file for upload

      const reader = new FileReader();
      reader.onload = (event) => {
        setProfileImage(event.target.result); // preview only
      };
      reader.readAsDataURL(file);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmShowPassword(!confirmShowPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (role === "") {
      toast.error("Role are required");
      setIsCheckRole(true);
      return;
    } else if (firstName === "") {
      toast.error("First Name are required");
      setIsCheckFirstName(true);
      return;
    } else if (lastName === "") {
      toast.error("Last Name are required");
      setIsCheckLastName(true);
      return;
    } else if (email === "") {
      toast.error("Email are required");
      setIsCheckEmail(true);
      return;
    } else if (phone === "") {
      toast.error("Phone are required");
      setIsCheckPhone(true);
      return;
    } else if (password === "") {
      if (!isEditMode) {
        toast.warn("Please enter your password");
        setIsCheckPassword(true);
        return;
      }
    } else if (confirmPassword === "") {
      if (!isEditMode) {
        toast.warn("Please enter your password");
        setIsCheckConfirmPassword(true);
        return;
      }
    } else if (password !== confirmPassword) {
      if (!isEditMode) {
        toast.warn("Passwords do not match");
        setIsCheckMatch(true);
        return;
      }
    }

    setlaoding(true);
    if (isEditMode) {
      try {
        setlaoding(true);
        const selectedUser = users.find((u) => u.id === id);

        let uploadedImageURL = selectedUser?.profilepicture || "";

        // ✅ Agar new image select hui hai (File object)
        if (profileImageFile instanceof File) {
          uploadedImageURL = await uploadImageToUser(
            profileImageFile,
            "userProfileImages",
          );
        }

        await setDoc(
          doc(firestored, "users", id),
          {
            firstname: firstName,
            lastname: lastName,
            phonenumber: phone,
            role: role,
            profilepicture: uploadedImageURL,
            rankingaccess: rankingaccess,
            isDemo: isDemo,
            type: selectedUser.type ? selectedUser.type : 0,
            ...(role === "Employee" && {
              yearlyGoals: agentGoals,
              closedyearlygoals: agentunitsclosedgoal,
              closedvolumeyearlygoals: agentvolumesoledgoal,
            }),
            ...(role?.trim().toLowerCase() === "supervisor" && {
              access: access,
            }),
          },
          { merge: true },
        );

        getallusers();
        toast.success("User updated successfully!");
        navigate("/dashboard/settings?tab=userManagment");
      } catch (err) {
        toast.error(err.message);
      } finally {
        setlaoding(false);
      }
      return;
    } else {
      try {
        // ✅ Create a completely new secondary auth instance
        const secondaryApp = initializeApp(firebaseConfig, "Secondary");
        const secondaryAuth = getAuth(secondaryApp);

        // ✅ Create user using secondary instance
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          email,
          password,
        );
        const newUser = userCredential.user;

        // ⬆ Upload image if selected
        let uploadedImageURL = "";
        if (profileImageFile) {
          uploadedImageURL = await uploadImageToUser(
            profileImageFile,
            "userProfileImages",
          );
        }

        // ✅ Save user data in Firestore
        const userData = {
          id: newUser.uid,
          firstname: firstName,
          lastname: lastName,
          email: email,
          phonenumber: phone,
          profilepicture: uploadedImageURL,
          role: role,
          rankingaccess: rankingaccess,
          isDemo: isDemo,
          isShowStats: false,
          ...(role === "Employee" && {
            yearlyGoals: agentGoals,
            closedyearlygoals: agentunitsclosedgoal,
            closedvolumeyearlygoals: agentvolumesoledgoal,
          }),
          ...(role?.trim().toLowerCase() === "supervisor" && {
            access: access,
          }),
        };

        await setDoc(doc(firestored, "users", newUser.uid), userData);
        getallusers();
        toast.success("User successfully created!");

        // ✅ Sign out the secondary auth (not the main admin)
        await signOut(secondaryAuth);

        await deleteApp(secondaryApp);
        setFirstName("");
        setLastName("");
        setEmail("");
        setProfileImage(null);
        setPhone("");
        setRole("");
        setConfirmPassword("");
        setPassword("");
        navigate("/dashboard/settings?tab=userManagment");
      } catch (error) {
        console.error("Error creating user:", error);
        toast.error(error.message);
      } finally {
        setlaoding(false);
      }
    }
  };

  async function getallusers() {
    await getAllusers("users")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_ALLUSERS,
          teamleads: response.filter(function (doc) {
            return doc.role === "Admin";
          }),
          clients: response.filter(function (doc) {
            return doc.role === "Supervisor";
          }),
          employees: response.filter(function (doc) {
            return doc.role === "Employee";
          }),
          allusers: response,
        });
      })
      .catch((err) => {
        toast.error(String(err?.message || err));
      });
  }

  useEffect(() => {
    if (!isEditMode || !users?.length) return;

    const selectedUser = users.find((u) => u.id === id);

    if (selectedUser) {
      setFirstName(selectedUser.firstname || "");
      setLastName(selectedUser.lastname || "");
      setEmail(selectedUser.email || "");
      setPhone(selectedUser.phonenumber || "");
      setRole(selectedUser.role || "");
      setIsDemo(Boolean(selectedUser.isDemo));
      setrankingaccess(selectedUser.rankingaccess || false);
      setProfileImage(selectedUser.profilepicture || null);
      if (selectedUser.yearlyGoals?.length) {
        setAgentGoals(selectedUser.yearlyGoals);
      }
      if (selectedUser.closedyearlygoals?.length) {
        setagentunitsclosedgoal(selectedUser.closedyearlygoals);
      }
      if (selectedUser.closedvolumeyearlygoals?.length) {
        setagentvolumesoledgoal(selectedUser.closedvolumeyearlygoals);
      }
      if (selectedUser.role === "Supervisor" && selectedUser.access) {
        setAccess((prev) => {
          const updatedAccess = { ...prev };

          ACCESS_LIST.forEach((item) => {
            if (selectedUser.access.hasOwnProperty(item.key)) {
              updatedAccess[item.key] = Boolean(selectedUser.access[item.key]);
            }
          });

          return updatedAccess;
        });
      } else {
        setAccess((prev) => {
          const updatedAccess = { ...prev };

          ACCESS_LIST.forEach((item) => {
            updatedAccess[item.key] = false;
          });

          return updatedAccess;
        });
      }
    }
  }, [isEditMode, id, users]);

  function formatPhone(value) {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return (
    <div className="mb-5 lg:mb-0">
      {/* Bulk Upload removed 2026-08-01 (Henry) — users are added one at a
          time here; the importer stays in the codebase, just unlinked. */}
      <PageHeader title="User Registration" />
      {(isEditMode || page === "teammanagment" || page === "usermanagment") && (
        <div className="px-10 mt-3">
          <BreadCrumbs
            crumb1={
              page === "usermanagment" ? "User Management" : "Team Management"
            }
            crumb2="User Registration"
          />
        </div>
      )}

      <form
        className="w-[90%] lg:w-[80%] mx-auto mt-10 h-full"
        onSubmit={handleSubmit}
      >
        <div className="flex justify-center ">
          <div
            className="size-28 lg:size-40 rounded-full border-2 border-gray-200 relative cursor-pointer"
            onClick={() => {
              fileInputRef.current.click();
            }}
          >
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="size-full object-cover rounded-full"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-[50px] lg:size-[100px]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                  />
                </svg>
              </div>
            )}

            <div className="absolute top-0 right-0 bg-gradient-to-b from-[#0f172a] to-[#1E293B] p-2 rounded-full z-50">
              <Camera className="text-white" size={20} />
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            ref={fileInputRef}
            onChange={handleImageChange}
          />
        </div>
        <div className="mt-6">
          <label className="block font-medium text-sm mb-1">Select Role</label>

          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className={`w-full ${
              isCheckrole ? "border-2 border-red-600" : ""
            } rounded-lg p-2 focus:border-[#1E293B] outline-none`}
          >
            <option value="" disabled>
              -- Select Role --
            </option>
            {(isSuperAdminOwner(user) || role === "Admin") && (
              <option value="Admin">Team Lead</option>
            )}
            {user.role !== "Supervisor" && (
              <option value="Supervisor">Client Care</option>
            )}
            <option value="Employee">Real Estate Agent</option>
            <option value="Accountant">Accountant</option>
          </select>
        </div>

        {isSuperAdminOwner(user) && (
          <div className="flex items-center justify-between w-full mt-5">
            <div>
              <p className="block font-medium text-lg">Demo user</p>
              <p className="text-sm text-gray-500">
                Can preview every role except Super Admin from a "View as" menu.
              </p>
            </div>
            <button
              type="button"
              onClick={() => setIsDemo((v) => !v)}
              className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 ${
                isDemo ? "bg-themeColor" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                  isDemo ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        )}

        <div className="flex flex-col lg:flex-row lg:justify-between mt-5">
          <div className="w-full lg:w-[49%]">
            <label className="block font-medium text-sm mb-1">First Name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter your first name.."
              className={`w-full mt-1 ${
                isCheckFirstName ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
          <div className="w-full lg:w-[49%] mt-4 lg:mt-0">
            <label className="block font-medium text-sm mb-1">Last Name</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter your last name.."
              className={`w-full mt-1 ${
                isCheckLastName ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row lg:justify-between mt-5">
          <div className="w-full lg:w-[49%]">
            <label className="block font-medium text-sm mb-1">Email</label>
            <input
              type="text"
              value={email}
              disabled={isEditMode}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email.."
              className={`w-full mt-1 bg-white ${
                isEditMode ? "cursor-not-allowed" : ""
              } ${
                isCheckEmail ? "border-2 border-red-600" : ""
              } text-sm rounded-lg  px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
          <div className="w-full lg:w-[49%] mt-4 lg:mt-0">
            <label className="block font-medium text-sm mb-1">
              Phone Number
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(formatPhone(e.target.value))}
              placeholder="Enter your phone number.."
              className={`w-full mt-1 ${
                isCheckPhone ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
        </div>

        {!isEditMode && (
          <div className="flex flex-col lg:flex-row justify-between mt-4">
            <div className="w-full lg:w-[49%]">
              <label className="block font-medium text-sm mb-1">
                Password*
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  disabled={isEditMode}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Create password.."
                  className={`bg-white ${
                    isEditMode ? "cursor-not-allowed" : ""
                  } ${
                    isCheckPassword ? "border-2 border-red-600" : ""
                  }w-full mt-1 text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
                />
                {!isEditMode && (
                  <div
                    className="absolute right-3 top-3 text-stone-950/40 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
                  </div>
                )}
              </div>
            </div>
            <div className="w-full lg:w-[49%] mt-4 lg:mt-0">
              <label className="block font-medium text-sm mb-1">
                Confirm Password*
              </label>
              <div className="relative">
                <input
                  type={confirmShowPassword ? "text" : "password"}
                  value={confirmPassword}
                  disabled={isEditMode}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm password.."
                  className={`${isEditMode ? "cursor-not-allowed" : ""} ${
                    isCheckMatch || isCheckMatch
                      ? "border-2 border-red-600"
                      : ""
                  }w-full mt-1 text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
                />
                {!isEditMode && (
                  <div
                    className="absolute right-3 top-3 text-stone-950/40 cursor-pointer"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {confirmShowPassword ? (
                      <Eye size={20} />
                    ) : (
                      <EyeOff size={20} />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {role === "Supervisor" && (
          <div className="gap-y-4 md:gap-x-[2%] lg:gap-x-[3%] flex flex-wrap mt-6">
            {ACCESS_LIST.map((item) => {
              const isActive = access[item.key];

              return (
                <div
                  key={item.key}
                  className="flex items-center justify-between w-full md:w-[49%] lg:w-[30%]"
                >
                  <p className="text-base">{item.label}</p>

                  <button
                    type="button"
                    onClick={() => toggleAccess(item.key)} // ✅ important
                    className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 ${
                      isActive ? "bg-themeColor" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                        isActive ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>
              );
            })}
          </div>
        )}
        {(role === "Employee" || role === "Admin") && (
          <div className="flex items-center justify-between w-full  mt-[30px]">
            <p className="block font-medium text-lg ">{"Team Ranking"}</p>

            <button
              type="button"
              onClick={() => toggleRankingAccess()} // ✅ important
              className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 ${
                rankingaccess ? "bg-themeColor" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                  rankingaccess ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        )}
        {role === "Employee" && (
          <>
            <div className="mt-6 p-4 border rounded-lg bg-gray-50">
              <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold mb-4">
                  Closed Units Goal
                </h3>
                <button
                  type="button"
                  onClick={addClosedDealGoalYear}
                  className="mt-2 text-sm text-white rounded-full p-2 font-medium bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300"
                >
                  <Plus />
                </button>
              </div>
              <div className="flex items-center flex-wrap gap-x-[2%] lg:gap-x-[5%]">
                {agentunitsclosedgoal.map((item, index) => (
                  <div
                    key={item.year}
                    className="mb-3 w-full md:w-[49%] lg:w-[30%] "
                  >
                    <div className="flex flex-col">
                      <label className="mb-1 font-medium">{item.year}</label>

                      <div className="flex items-center gap-x-2">
                        <input
                          type="text"
                          placeholder={`Enter ${item.year} goal - Closed Units`}
                          value={formatNumber(item.count)}
                          onChange={(e) => {
                            const rawValue = removeCommas(
                              e.target.value,
                            ).replace(/[^0-9]/g, "");
                            updateclosedGoalAmount(index, rawValue);
                          }}
                          className="flex-1 rounded-lg border px-4 py-2 text-sm"
                        />
                        <button
                          type="button"
                          onClick={() => removeclosedGoalYear(index)}
                          className="text-red-600 text-sm"
                        >
                          <Trash2 size={22} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-6 p-4 border rounded-lg bg-gray-50">
              <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold mb-4">Volume Goal</h3>
                <button
                  type="button"
                  onClick={addVolumeGoalYear}
                  className="mt-2 text-sm text-white rounded-full p-2 font-medium bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300"
                >
                  <Plus />
                </button>
              </div>
              <div className="flex items-center flex-wrap gap-x-[2%] lg:gap-x-[5%]">
                {agentvolumesoledgoal.map((item, index) => (
                  <div
                    key={item.year}
                    className="mb-3 w-full md:w-[49%] lg:w-[30%] "
                  >
                    <div className="flex flex-col">
                      <label className="mb-1 font-medium">{item.year}</label>

                      <div className="flex items-center gap-x-2">
                        <input
                          type="text"
                          placeholder={`Enter ${item.year} goal - Closed Volume`}
                          value={formatNumber(item.amount)}
                          onChange={(e) => {
                            const rawValue = removeCommas(
                              e.target.value,
                            ).replace(/[^0-9]/g, "");
                            updateclosedvolumeAmount(index, rawValue);
                          }}
                          className="flex-1 rounded-lg border px-4 py-2 text-sm"
                        />
                        <button
                          type="button"
                          onClick={() => removedvolumegoalyear(index)}
                          className="text-red-600 text-sm"
                        >
                          <Trash2 size={22} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-6 p-4 border rounded-lg bg-gray-50">
              <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold mb-4">GCI Goal</h3>
                <button
                  type="button"
                  onClick={addGoalYear}
                  className="mt-2 text-sm text-white rounded-full p-2 font-medium bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300"
                >
                  <Plus />
                </button>
              </div>
              <div className="flex items-center flex-wrap gap-x-[2%] lg:gap-x-[5%]">
                {agentGoals.map((item, index) => (
                  <div
                    key={item.year}
                    className="mb-3 w-full md:w-[49%] lg:w-[30%] "
                  >
                    <div className="flex flex-col">
                      <label className="mb-1 font-medium">{item.year}</label>

                      <div className="flex items-center gap-x-2">
                        <input
                          type="text"
                          placeholder={`Enter ${item.year} goal - Closed Commission`}
                          value={formatNumber(item.amount)}
                          onChange={(e) => {
                            const rawValue = removeCommas(
                              e.target.value,
                            ).replace(/[^0-9]/g, "");
                            updateGoalAmount(index, rawValue);
                          }}
                          className="flex-1 rounded-lg border px-4 py-2 text-sm"
                        />
                        <button
                          type="button"
                          onClick={() => removeGoalYear(index)}
                          className="text-red-600 text-sm"
                        >
                          <Trash2 size={22} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        <div className="flex justify-center my-6 ">
          <button
            type="submit"
            className="text-base font-medium bg-themeColor shadow-md hover:bg-themeColor/90  mt-3 flex justify-center items-center text-white rounded-full py-[10px] px-20"
          >
            {isEditMode ? "Update User" : "Create User"}
            {laoding && (
              <div role="status" className="pl-3">
                <svg
                  aria-hidden="true"
                  class="w-6 h-6 text-gray-200 animate-spin dark:text-white fill-[#1E293B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </button>
        </div>
      </form>

    </div>
  );
}
